var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

import React, { useCallback, useRef } from "react";
import { Input, Hint } from "react-bootstrap-typeahead";
import { Badge } from "./../../../index";
import ClearButton from "./ClearButton";
var _input = void 0;

var Tokens = function Tokens(_ref) {
  var selectedValue = _ref.selectedValue,
      labelKey = _ref.labelKey;

  if (selectedValue.length === 0) {
    return null;
  }

  var label = selectedValue[0][labelKey];

  return React.createElement(
    Badge,
    { className: "mr-2", variant: "primary", key: label },
    label,
    selectedValue.length > 1 ? " + " + (selectedValue.length - 1) : ""
  );
};
var SelectMultiInput = function SelectMultiInput(_ref2) {
  var inputRef = _ref2.inputRef,
      referenceElementRef = _ref2.referenceElementRef,
      shouldSelectHint = _ref2.shouldSelectHint,
      selectedValue = _ref2.selectedValue,
      size = _ref2.size,
      placeholder = _ref2.placeholder,
      clearButton = _ref2.clearButton,
      onClickClear = _ref2.onClickClear,
      isOpen = _ref2.isOpen,
      labelKey = _ref2.labelKey,
      required = _ref2.required,
      inputProps = _objectWithoutProperties(_ref2, ["inputRef", "referenceElementRef", "shouldSelectHint", "selectedValue", "size", "placeholder", "clearButton", "onClickClear", "isOpen", "labelKey", "required"]);

  var wrapperRef = useRef();

  var getInputRef = function getInputRef(input) {
    _input = input;
    inputRef(input);
  };
  var handleContainerClickOrFocus = useCallback(function (e) {
    // Don't focus the input if it's disabled.
    if (inputProps.disabled) {
      e.currentTarget.blur();
      return;
    }

    // Move cursor to the end if the user clicks outside the actual input.
    var inputNode = _input;

    if (!inputNode) {
      return;
    }

    if (inputNode.selectionStart != null) {
      inputNode.selectionStart = inputNode.value.length;
    }

    inputNode.focus();
  }, [inputProps.disabled]);

  return React.createElement(
    "div",
    {
      className: "custom-select rbt-input-multi form-control rbt-input form-select-multi " + (isOpen ? "selected" : "") + " " + (size ? "form-control-" + size : ""),
      disabled: inputProps.disabled,
      onClick: handleContainerClickOrFocus,
      onFocus: handleContainerClickOrFocus,
      ref: referenceElementRef,
      tabIndex: -1
    },
    React.createElement(
      "div",
      { className: "rbt-input-wrapper", ref: wrapperRef },
      React.createElement(Tokens, { selectedValue: selectedValue, labelKey: labelKey }),
      React.createElement(
        Hint,
        { shouldSelect: shouldSelectHint },
        React.createElement(Input, _extends({}, inputProps, {
          placeholder: selectedValue.length ? "" : placeholder,
          ref: getInputRef,
          required: required,
          style: {
            backgroundColor: "transparent",
            border: 0,
            boxShadow: "none",
            cursor: "inherit",
            outline: "none",
            padding: 0,
            width: "100%",
            zIndex: 1
          },
          autoComplete: "null"
        }))
      ),
      clearButton && React.createElement(ClearButton, { onClick: onClickClear })
    )
  );
};
export default SelectMultiInput;